// Finish my deck's PUBLIC gate. /pro/status needs a bearer, so a signed-out
// reader can only be told about Finish by the build. Same two switches as the
// Scan CTA (src/lib/scanCta.ts):
//  - VITE_FINISH_DECK (build time, default OFF; "1" or "true" turns it on);
//  - a per-browser override in localStorage (`cb.finishDeck` = "1" / "0"),
//    written by `?finish_deck=1|0` on any page and removed by `?finish_deck=clear`.
// Signed in, the /pro/status `finish` block is the second gate (see
// components/decks/editor/finish/finishLogic.ts finishAvailability).
import { FINISH_DECK_QUERY_PARAM, FINISH_DECK_STORAGE_KEY } from './finishDeck.codes'
import { createPreviewFlag, envOn } from './previewFlag'

const flag = createPreviewFlag(FINISH_DECK_STORAGE_KEY, FINISH_DECK_QUERY_PARAM, envOn(import.meta.env.VITE_FINISH_DECK))

/** True when this page load may show Finish my deck at all. Stable for the session. */
export function finishDeckEnabled(): boolean {
  return flag.enabled()
}

/** Test seam. */
export function __resetFinishDeckFlagForTests(): void {
  flag.reset()
}
